import { makeStyles } from '@material-ui/core/styles'
import { FORM_VARIANTS } from '../Sections.const'

const useStyles = makeStyles(
	theme => ({
		root: {
			zIndex: 1,
			[`&.${FORM_VARIANTS.VARIANT_1}`]: {
				position: 'relative',

				[theme.breakpoints.down('xs')]: {
					position: 'initial',
				},
			},
			[`&.${FORM_VARIANTS.VARIANT_4}`]: {
				display: 'flex',
				alignItems: 'center',
			},
			[`&.${FORM_VARIANTS.VARIANT_6}`]: {
				display: 'flex',
				alignItems: 'flex-end',
			},
		},
	}),
	{ name: 'Form' },
)

export default useStyles
